import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
class RandomRewardChestData_RandomRewardData {
  get descriptor() {
    return RandomRewardChestData_RandomRewardData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
    this._hasDropRate = false;
    this._dropRate = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue) return false;
    if (this._hasDropRate) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RandomRewardChestData_RandomRewardData) {
      return value;
    }
    return RandomRewardChestData_RandomRewardData.fromJson(value);
  }
  static fromJson(json) {
    const result = new RandomRewardChestData_RandomRewardData();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToInt32.fromJson(json.value);
    }
    if (json.dropRate != null) {
      result._hasDropRate = true;
      result._dropRate = JsonToDouble.fromJson(json.dropRate);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue) {
      result.value = JsonToInt32.toJson(this._value);
    }
    if (this._hasDropRate) {
      result.dropRate = JsonToDouble.toJson(this._dropRate);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToInt32.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {number}
   */
  get dropRate() {
    return this._hasDropRate ? this._dropRate : JsonToDouble.default;
  }
  get hasDropRate() {
    return this._hasDropRate;
  }
  setDropRate(path, value) {
    return {type: 'SET', path: path.concat(['dropRate']), value};
  }
  deleteDropRate(path) {
    return {type: 'DELETE', path: path.concat(['dropRate'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData_RandomRewardData(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new RandomRewardChestData_RandomRewardData(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData_RandomRewardData(this);
              copy._hasValue = true;
              copy._value = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new RandomRewardChestData_RandomRewardData(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dropRate": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData_RandomRewardData(this);
              copy._hasDropRate = true;
              copy._dropRate = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDropRate) {
                return this;
              }
              const copy = new RandomRewardChestData_RandomRewardData(this);
              copy._hasDropRate = false;
              copy._dropRate = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RandomRewardChestData_RandomRewardData} other
   * @returns {RandomRewardChestData_RandomRewardData}
   */
  merge(other) {
    const copy = new RandomRewardChestData_RandomRewardData(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    if (other._hasDropRate) {
      copy._hasDropRate = true;
      copy._dropRate = other._dropRate;
    }
    return copy;
  }
}
RandomRewardChestData_RandomRewardData.default = new RandomRewardChestData_RandomRewardData();
class RandomRewardChestData_RandomRewardData_Builder {
  constructor(value) {
    this._value = new RandomRewardChestData_RandomRewardData(value);
  }
  build() {
    return new RandomRewardChestData_RandomRewardData(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
  setDropRate(value) {
    this._value._hasDropRate = true;
    this._value._dropRate = value;
    return this;
  }
  deleteDropRate() {
    this._value._hasDropRate = false;
    this._value._dropRate = null;
    return this;
  }
}
RandomRewardChestData_RandomRewardData.Builder = RandomRewardChestData_RandomRewardData_Builder;
class RandomRewardChestData_RandomRewardData_WithParent {
  /**
   * @param {RandomRewardChestData_RandomRewardData} value
   * @param {RandomRewardChestData_RandomRewardData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RandomRewardChestData_RandomRewardData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  get hasDropRate() {
    if (this._cachedHasDropRate === undefined) {
      if (this._value.hasDropRate) {
        this._cachedHasDropRate = true;
      } else {
        this._cachedHasDropRate = this._parent ? this._parent.hasDropRate : false;
      }
    }
    return this._cachedHasDropRate;
  }
  get dropRate() {
    if (this._cachedDropRate === undefined) {
      if (this._value.hasDropRate) {
        this._cachedDropRate = this._value.dropRate;
      } else {
        this._cachedDropRate = this._parent ? this._parent.dropRate : this._value.dropRate;
      }
    }
    return this._cachedDropRate;
  }
  update(current, parent) {
    const result = new RandomRewardChestData_RandomRewardData_WithParent(current, parent);
    return result;
  }
}
RandomRewardChestData_RandomRewardData_WithParent.default = new RandomRewardChestData_RandomRewardData_WithParent(RandomRewardChestData_RandomRewardData.default, null);
RandomRewardChestData_RandomRewardData.WithParent = RandomRewardChestData_RandomRewardData_WithParent;
class RandomRewardChestData_RandomRewardData_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 5,
        protoName: "value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get dropRate() {
    if (!this._dropRate) {
      this._dropRate = {
        name: "dropRate",
        Name: "DropRate",
        number: 3,
        protoType: 1,
        protoName: "drop_rate",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dropRate;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
        this.dropRate,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDropRate",
        Name: "DummyOneofForDropRate",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
RandomRewardChestData_RandomRewardData.descriptor = new RandomRewardChestData_RandomRewardData_Descriptor();
class RandomRewardChestData_Chest {
  get descriptor() {
    return RandomRewardChestData_Chest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._randomRewardPool = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._randomRewardPool.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RandomRewardChestData_Chest) {
      return value;
    }
    return RandomRewardChestData_Chest.fromJson(value);
  }
  static fromJson(json) {
    const result = new RandomRewardChestData_Chest();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._randomRewardPool = JsonToList(json.randomRewardPool, RandomRewardChestData_RandomRewardData);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._randomRewardPool.length > 0) {
      result.randomRewardPool = ArrayToJson(this._randomRewardPool, RandomRewardChestData_RandomRewardData);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {RandomRewardChestData_RandomRewardData[]}
   */
  get randomRewardPool() {
    return this._randomRewardPool;
  }
  addRandomRewardPool(path, value) {
    return {type: 'ADD', path: path.concat(['randomRewardPool']), value: value.toJson()};
  }
  setRandomRewardPool(path, value) {
    return {type: 'SET', path: path.concat(['randomRewardPool']), value: ArrayToJson(value, RandomRewardChestData_RandomRewardData)};
  }
  setRandomRewardPoolByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['randomRewardPool', key]), value: value.toJson()};
  }
  deleteRandomRewardPool(path) {
    return {type: 'DELETE', path: path.concat(['randomRewardPool'])};
  }
  deleteRandomRewardPoolByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['randomRewardPool', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData_Chest(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new RandomRewardChestData_Chest(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "randomRewardPool": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData_Chest(this);
              copy._randomRewardPool = [];        for (let i of value) {
                copy._randomRewardPool.push(RandomRewardChestData_RandomRewardData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RandomRewardChestData_Chest(this);
              copy._randomRewardPool = copy._randomRewardPool.concat([RandomRewardChestData_RandomRewardData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._randomRewardPool.length === 0) {
                return this;
              }
              const copy = new RandomRewardChestData_Chest(this);
              copy._randomRewardPool = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._randomRewardPool.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData_Chest(this);
              copy._randomRewardPool = copy._randomRewardPool.slice();
              copy._randomRewardPool[path[1]] = RandomRewardChestData_RandomRewardData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RandomRewardChestData_Chest(this);
              copy._randomRewardPool = copy._randomRewardPool.slice(0, path[1]).concat(copy._randomRewardPool.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._randomRewardPool.length) {
            return this;
          }
          const oldValue = this._randomRewardPool[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RandomRewardChestData_Chest(this);
          copy._randomRewardPool = copy._randomRewardPool.slice();
          copy._randomRewardPool[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RandomRewardChestData_Chest} other
   * @returns {RandomRewardChestData_Chest}
   */
  merge(other) {
    const copy = new RandomRewardChestData_Chest(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._randomRewardPool = this._randomRewardPool.concat(other._randomRewardPool);
    return copy;
  }
}
RandomRewardChestData_Chest.default = new RandomRewardChestData_Chest();
class RandomRewardChestData_Chest_Builder {
  constructor(value) {
    this._value = new RandomRewardChestData_Chest(value);
  }
  build() {
    return new RandomRewardChestData_Chest(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllRandomRewardPool(values) {
    this._value._randomRewardPool = this._value._randomRewardPool.concat(values);
    return this;
  }
  addRandomRewardPool(value) {
    this._value._randomRewardPool = this._value._randomRewardPool.concat([value]);
    return this;
  }
  setRandomRewardPool(index, value) {
    this._value._randomRewardPool = this._value._randomRewardPool.concat();
    this._value._randomRewardPool[index] = value;
    return this;
  }
  clearRandomRewardPool() {
    this._value._randomRewardPool = [];
    return this;
  }
}
RandomRewardChestData_Chest.Builder = RandomRewardChestData_Chest_Builder;
class RandomRewardChestData_Chest_WithParent {
  /**
   * @param {RandomRewardChestData_Chest} value
   * @param {RandomRewardChestData_Chest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RandomRewardChestData_Chest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfRandomRewardPool() {
    if (!this._selfRandomRewardPool) {
      this._selfRandomRewardPool = [];
      for (let i of this._value.randomRewardPool) {
        this._selfRandomRewardPool.push(new RandomRewardChestData_RandomRewardData.WithParent(i, null));
      }
    }
    return this._selfRandomRewardPool;
  }
  get inherentRandomRewardPool() {
    if (!this._inherentRandomRewardPool) {
      this._inherentRandomRewardPool = this._parent ? this._parent.randomRewardPool : [];
    }
    return this._inherentRandomRewardPool;
  }
  get randomRewardPool() {
    if (!this._allRandomRewardPool) {
      this._allRandomRewardPool = this._parent ? this._parent.randomRewardPool.concat(this.selfRandomRewardPool) : this.selfRandomRewardPool;
    }
    return this._allRandomRewardPool;
  }
  update(current, parent) {
    const result = new RandomRewardChestData_Chest_WithParent(current, parent);
    if (this._selfRandomRewardPool) {
      if (this._value.randomRewardPool === current.randomRewardPool) {
        result._selfRandomRewardPool = this._selfRandomRewardPool;
      } else {
        result._selfRandomRewardPool = [];
        for (let i = 0; i < current.randomRewardPool.length; i++) {
          const oldValue = this._value.randomRewardPool[i];
          if (oldValue) {
            const oldCache = this._selfRandomRewardPool[i];
            if (oldValue === current.randomRewardPool[i]) {
              result._selfRandomRewardPool[i] = oldCache;
            } else {
              result._selfRandomRewardPool[i] = oldCache.update(current.randomRewardPool[i], null);
            }
          } else {
            result._selfRandomRewardPool[i] = new RandomRewardChestData_RandomRewardData.WithParent(current.randomRewardPool[i], null);
          }
        }
      }
    }
    return result;
  }
}
RandomRewardChestData_Chest_WithParent.default = new RandomRewardChestData_Chest_WithParent(RandomRewardChestData_Chest.default, null);
RandomRewardChestData_Chest.WithParent = RandomRewardChestData_Chest_WithParent;
class RandomRewardChestData_Chest_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get randomRewardPool() {
    if (!this._randomRewardPool) {
      this._randomRewardPool = {
        name: "randomRewardPool",
        Name: "RandomRewardPool",
        number: 2,
        protoType: 11,
        protoName: "random_reward_pool",
        type: RandomRewardChestData_RandomRewardData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._randomRewardPool;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.randomRewardPool,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
RandomRewardChestData_Chest.descriptor = new RandomRewardChestData_Chest_Descriptor();
export class RandomRewardChestData {
  get descriptor() {
    return RandomRewardChestData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._chests = [];
  }
  isEmpty() {
    if (this._chests.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof RandomRewardChestData) {
      return value;
    }
    return RandomRewardChestData.fromJson(value);
  }
  static fromJson(json) {
    const result = new RandomRewardChestData();
    result._chests = JsonToList(json.chests, RandomRewardChestData_Chest);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._chests.length > 0) {
      result.chests = ArrayToJson(this._chests, RandomRewardChestData_Chest);
    }
    return result;
  }
  /**
   * @returns {RandomRewardChestData_Chest[]}
   */
  get chests() {
    return this._chests;
  }
  addChests(path, value) {
    return {type: 'ADD', path: path.concat(['chests']), value: value.toJson()};
  }
  setChests(path, value) {
    return {type: 'SET', path: path.concat(['chests']), value: ArrayToJson(value, RandomRewardChestData_Chest)};
  }
  setChestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chests', key]), value: value.toJson()};
  }
  deleteChests(path) {
    return {type: 'DELETE', path: path.concat(['chests'])};
  }
  deleteChestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chests', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "chests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData(this);
              copy._chests = [];        for (let i of value) {
                copy._chests.push(RandomRewardChestData_Chest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new RandomRewardChestData(this);
              copy._chests = copy._chests.concat([RandomRewardChestData_Chest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chests.length === 0) {
                return this;
              }
              const copy = new RandomRewardChestData(this);
              copy._chests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new RandomRewardChestData(this);
              copy._chests = copy._chests.slice();
              copy._chests[path[1]] = RandomRewardChestData_Chest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new RandomRewardChestData(this);
              copy._chests = copy._chests.slice(0, path[1]).concat(copy._chests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chests.length) {
            return this;
          }
          const oldValue = this._chests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new RandomRewardChestData(this);
          copy._chests = copy._chests.slice();
          copy._chests[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {RandomRewardChestData} other
   * @returns {RandomRewardChestData}
   */
  merge(other) {
    const copy = new RandomRewardChestData(this);
    copy._chests = this._chests.concat(other._chests);
    return copy;
  }
}
RandomRewardChestData.default = new RandomRewardChestData();
RandomRewardChestData.RandomRewardData = RandomRewardChestData_RandomRewardData;
RandomRewardChestData.Chest = RandomRewardChestData_Chest;
class RandomRewardChestData_Builder {
  constructor(value) {
    this._value = new RandomRewardChestData(value);
  }
  build() {
    return new RandomRewardChestData(this._value);
  }
  addAllChests(values) {
    this._value._chests = this._value._chests.concat(values);
    return this;
  }
  addChests(value) {
    this._value._chests = this._value._chests.concat([value]);
    return this;
  }
  setChests(index, value) {
    this._value._chests = this._value._chests.concat();
    this._value._chests[index] = value;
    return this;
  }
  clearChests() {
    this._value._chests = [];
    return this;
  }
}
RandomRewardChestData.Builder = RandomRewardChestData_Builder;
class RandomRewardChestData_WithParent {
  /**
   * @param {RandomRewardChestData} value
   * @param {RandomRewardChestData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return RandomRewardChestData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfChests() {
    if (!this._selfChests) {
      this._selfChests = [];
      for (let i of this._value.chests) {
        this._selfChests.push(new RandomRewardChestData_Chest.WithParent(i, null));
      }
    }
    return this._selfChests;
  }
  get inherentChests() {
    if (!this._inherentChests) {
      this._inherentChests = this._parent ? this._parent.chests : [];
    }
    return this._inherentChests;
  }
  get chests() {
    if (!this._allChests) {
      this._allChests = this._parent ? this._parent.chests.concat(this.selfChests) : this.selfChests;
    }
    return this._allChests;
  }
  update(current, parent) {
    const result = new RandomRewardChestData_WithParent(current, parent);
    if (this._selfChests) {
      if (this._value.chests === current.chests) {
        result._selfChests = this._selfChests;
      } else {
        result._selfChests = [];
        for (let i = 0; i < current.chests.length; i++) {
          const oldValue = this._value.chests[i];
          if (oldValue) {
            const oldCache = this._selfChests[i];
            if (oldValue === current.chests[i]) {
              result._selfChests[i] = oldCache;
            } else {
              result._selfChests[i] = oldCache.update(current.chests[i], null);
            }
          } else {
            result._selfChests[i] = new RandomRewardChestData_Chest.WithParent(current.chests[i], null);
          }
        }
      }
    }
    return result;
  }
}
RandomRewardChestData_WithParent.default = new RandomRewardChestData_WithParent(RandomRewardChestData.default, null);
RandomRewardChestData.WithParent = RandomRewardChestData_WithParent;
class RandomRewardChestData_Descriptor {
  get chests() {
    if (!this._chests) {
      this._chests = {
        name: "chests",
        Name: "Chests",
        number: 1,
        protoType: 11,
        protoName: "chests",
        type: RandomRewardChestData_Chest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chests;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.chests,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
RandomRewardChestData.descriptor = new RandomRewardChestData_Descriptor();
